import { useGetAddressCodeList } from "@/hooks/useGetAddressCodeList";
import { useMemo } from "react";

type UseGetAddressCodeReturn = {
  getAddressCode: (addressName: string) => string;
};

export const useGetAddressCode = (): UseGetAddressCodeReturn => {
  const { data: addressCodeList } = useGetAddressCodeList();

  const addressCodeMap = useMemo(() => {
    if (!addressCodeList) return [];

    return [...addressCodeList].sort((a, b) => b.addressName.length - a.addressName.length);
  }, [addressCodeList]);

  const getAddressCode = (address: string): string => {
    if (!address || !addressCodeMap.length) return "";

    const normalized = address.trim().replace(/\s+/g, "");

    const matched = addressCodeMap.find((item) => normalized.startsWith(item.addressName));

    return matched?.addressCode ?? "";
  };

  return { getAddressCode };
};
